import React, { useEffect } from 'react';
import { useConfirmation } from '../../hooks/confirmation';
import { Confirmation } from '@revenuewell/ui-dialogs';

export const AppConfirmation: React.FC = () => {
    const { action, closeConfirmation } = useConfirmation();

    const onConfimClick = async () => {
        await action.confirm.onClick();
        closeConfirmation();
    };

    const onCancelClick = async () => {
        if (action.cancel && action.cancel.onClick) {
            action.cancel.onClick();
        }
        closeConfirmation();
    };

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {action &&
                <Confirmation
                    title={action.title}
                    subtitle={action.subtitle}
                    visible={action != null}
                    actions={{
                        confirm: {
                            onClick: onConfimClick,
                            content: action.confirm.text ?? "Confirm",
                            color: action.confirm.isPermanetAction ? "error" : "primary"
                        },
                        cancel: action.cancel ? {
                            onClick: onCancelClick,
                            content: action.cancel.text ?? "Cancel"
                        } : null
                    }}
                    onClose={onCancelClick}
                >
                    {action.content}
                </Confirmation>
            }
        </>
    );
};